var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.6047C12.5725 10.6047 10.6047 12.5725 10.6047 15C10.6047 17.4275 12.5725 19.3953 15 19.3953C17.4275 19.3953 19.3953 17.4275 19.3953 15C19.3953 12.5725 17.4275 10.6047 15 10.6047ZM9.34884 15C9.34884 11.8789 11.8789 9.34884 15 9.34884C18.1211 9.34884 20.6512 11.8789 20.6512 15C20.6512 18.1211 18.1211 20.6512 15 20.6512C11.8789 20.6512 9.34884 18.1211 9.34884 15Z",
    fill: "#1B1D28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6C15.3468 6 15.6279 6.28112 15.6279 6.62791V7.46512C15.6279 7.8119 15.3468 8.09302 15 8.09302C14.6532 8.09302 14.3721 7.8119 14.3721 7.46512V6.62791C14.3721 6.28112 14.6532 6 15 6Z",
    fill: "#1B1D28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.907C15.3468 21.907 15.6279 22.1881 15.6279 22.5349V23.3721C15.6279 23.7189 15.3468 24 15 24C14.6532 24 14.3721 23.7189 14.3721 23.3721V22.5349C14.3721 22.1881 14.6532 21.907 15 21.907Z",
    fill: "#1B1D28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15C24 15.3468 23.7189 15.6279 23.3721 15.6279H22.5349C22.1881 15.6279 21.907 15.3468 21.907 15C21.907 14.6532 22.1881 14.3721 22.5349 14.3721H23.3721C23.7189 14.3721 24 14.6532 24 15Z",
    fill: "#1B1D28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09302 15C8.09302 15.3468 7.8119 15.6279 7.46512 15.6279H6.62791C6.28112 15.6279 6 15.3468 6 15C6 14.6532 6.28112 14.3721 6.62791 14.3721H7.46512C7.8119 14.3721 8.09302 14.6532 8.09302 15Z",
    fill: "#1B1D28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.364 8.63604C21.6092 8.88125 21.6092 9.27882 21.364 9.52403L20.772 10.116C20.5268 10.3612 20.1292 10.3612 19.884 10.116C19.6388 9.87082 19.6388 9.47325 19.884 9.22804L20.476 8.63604C20.7212 8.39083 21.1187 8.39083 21.364 8.63604Z",
    fill: "#1B1D28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.116 19.884C10.3612 20.1292 10.3612 20.5268 10.116 20.772L9.52403 21.364C9.27882 21.6092 8.88125 21.6092 8.63604 21.364C8.39083 21.1187 8.39083 20.7212 8.63604 20.476L9.22804 19.884C9.47325 19.6388 9.87082 19.6388 10.116 19.884Z",
    fill: "#1B1D28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.364 21.364C21.1187 21.6092 20.7212 21.6092 20.476 21.364L19.884 20.772C19.6388 20.5268 19.6388 20.1292 19.884 19.884C20.1292 19.6388 20.5268 19.6388 20.772 19.884L21.364 20.476C21.6092 20.7212 21.6092 21.1187 21.364 21.364Z",
    fill: "#1B1D28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.116 10.116C9.87082 10.3612 9.47325 10.3612 9.22804 10.116L8.63604 9.52403C8.39083 9.27882 8.39083 8.88125 8.63604 8.63604C8.88125 8.39083 9.27882 8.39083 9.52403 8.63604L10.116 9.22803C10.3612 9.47325 10.3612 9.87082 10.116 10.116Z",
    fill: "#1B1D28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBtn);
export default __webpack_public_path__ + "static/media/light-btn.a58c3fc7da09e0b3a1d5d2d3a18be24a.svg";
export { ForwardRef as ReactComponent };